/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from "@utils/loadable";

export const QJoinPage = lazyLoad(
  () => import("./index"),
  (module) => module.QJoinPage
);
